import { Row, Col, Input, Icon, Modal, Divider } from 'antd';
import { HomeCaptchaForm } from '@bit/ui-common.ui-components/ss-components';
import { passwordReset as config } from './formConfig';
import { ssFormUtils, ssFormValidationUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import AfspForgotPasswordControls from '../controls/AfspForgotPasswordControls';
import { PasswordResetPending, PasswordResetSuccess, PasswordResetFailure } from './AfspFormStatus';

const 
{ key } = config, { 
    setEnvPrefix, 
    simpleObjectCompare 
} = ssCommonUtils, { 
    validateForm, 
    validateSubForm,
} = ssFormValidationUtils, { 
    generateInputComponent, 
    setMaxWidth 
} = ssFormUtils;

export default class extends React.Component {
    constructor(props) { 
        super(props); 
        this.updateCaptchaField = this.updateCaptchaField.bind(this);
    }
    state = {
        captchaInput: ''
    };

    componentDidUpdate(prev) {
        const 
        { services, state: { registrationForm }} = this.props,
        form = registrationForm[key],
        prevForm = prev.state.registrationForm[key],
        { storeForm } = services;

        if(!simpleObjectCompare(prevForm, form)) {
            const formState = validateForm(form, config, true);
            storeForm(key, formState);
            this.setState({ isValid: validateSubForm(formState) });
        }

        this.shouldDisablePasswordResetButton(prev);
    }

    updateCaptchaField(e){
        const
        { services } = this.props,
        value = e.target.value;
        console.log('update captcha');
        console.log(services);
        if(this.state.captchaInput.length !== 8 && value.length === 8){
            services.checkCaptcha(value);
        }
        this.setState((state,props) => {
            return {...state, 
                    captchaFormProps: {...state.captchaFormProps, field:value},
                    captchaInput: value
                     }
           });
    }
    shouldDisablePasswordResetButton(prev) {
        const 
        { services, state } = this.props,
        cLoginButtonDisabled = state.login.loginButtonDisabled,
        cCaptchaValidationStatus = state.captcha.validation.status,
        cForm = state.registrationForm[key],
        cCaptchaForm = state.captcha,
        pForm = prev.state.registrationForm[key],
        pCaptchaForm = prev.state.captcha;

        if (JSON.stringify(pForm) !== JSON.stringify(cForm) || JSON.stringify(pCaptchaForm) !== JSON.stringify(cCaptchaForm)) {
            if (cForm.userIdOrEmail.length <= 0 || cForm.userIdOrEmail_status !== 'success' || cCaptchaValidationStatus !== 'success') {
                if (!cLoginButtonDisabled) services.toggleAfspLoginButtonDisable();
            } else if (cCaptchaValidationStatus === 'success' && cLoginButtonDisabled) 
                services.toggleAfspLoginButtonDisable();
        }
    }

    render() {
        const 
        { services, state } = this.props,
        { registrationForm, login: { showPasswordResetModal, passwordResetRequest: { status }}} = state,
        { storeForm, storeFormField } = services, 
        form = registrationForm[key],
        {captchaInput} = this.state;

        return (
            <Modal
                visible={showPasswordResetModal}
                closable={false}
                footer={null}
                centered={true}
                width={290}
                mask={false}
                bodyStyle={{ padding: '15px' }}
            >
                <div className='afsp-login-mask-shader-light' />
                <Divider style={{ margin: '0px 0px 15px 0px' }}>
                    <span className='afsp-login-divider-title' style={{ fontSize: '14px' }}>
                        {'User ID or Password Reset'}
                    </span>
                </Divider>
                {
                    status === 'pending' ? <PasswordResetPending {...this.props} />
                    : status === 'success' ? <PasswordResetSuccess {...this.props} /> 
                    : status === 'failure' ? <PasswordResetFailure {...this.props} /> : (
                        <div>
                            <Row type='flex' justify='space-around' align='middle'>
                                <Col>
                                    <Input 
                                        {...{...generateInputComponent('userIdOrEmail', config, true, form, storeFormField, storeForm), style: { width: '241px' }}} 
                                        prefix={<Icon type='user' style={{ fontSize: '13px', color: 'rgba(0,0,0,.25)' }} />} 
                                        placeholder='User ID or Email address'
                                    />
                                </Col>
                            </Row>
                            <Row type='flex' justify='space-around' align='middle'>
                                <Col>
                                    <HomeCaptchaForm
                                        state={state.captcha}
                                        updateCaptchaField={this.updateCaptchaField}
                                        captchaInput={captchaInput}
                                        services={services}
                                    />
                                </Col>
                            </Row>
                        </div>
                    )
                }
                <AfspForgotPasswordControls {...this.props} captchaInput={captchaInput} />
            </Modal>
        );
    }
}